import Activities1 from "./Activities1"
import Home from "./Home"
import Activities2 from "./Activities2"
import Activities3 from "./Activities3"
import Activities5 from "./Activities5"
import Language from "./Language"

let actions={
    Home,
    Activities1,
    Activities2,
    Activities3,
    Activities5,
    Language,

};
export default actions


// WEBPACK FOOTER //
// ./src/store/actions/index.js